module.exports = __webpack_public_path__ + "static/media/9b.b9852c83.svg";